import styled from "styled-components";
import { mobileSize } from "Themes/Metrics";

export const InputContainer = styled.div`
  padding: 10px 0px;
`;
export const FormContainer = styled.form`
  display: flex;
  padding: 20px;
`;

export const MainContainer = styled.div`
  margin: auto;
  width: 60%;
  @media ${mobileSize.large} {
    width: 100%;
  }
`;

export const LeftContainer = styled.div`
  flex: 1;
`;

export const RightContainer = styled.div`
  flex: 1;
  border: solid 2px lightgray;
  cursor: pointer;
  border-radius: 5px;
  margin:0px 15px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  width: 30%;
  float: right;
`;